/**
 * @enum {number}
 */
const EWorkflowStep = {
    Creation: 1,
    AddressValidation: 2,
    OperatorsValidation: 3,
    OrderPlacedInImagine: 4,
    QuoteRequest: 5,
    QuoteCosting: 6,
    QuoteConfirmation: 7,
    QuoteRefused: 8,
    QuoteAccepted: 9,
}

export default EWorkflowStep
